import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchSourceConversionReport } from "../../../state/reducers/sourceConversionReportSlice";
import { Bar, Line, Pie } from "react-chartjs-2";
import "chart.js/auto";

const SourceConversionReport = () => {
  const dispatch = useDispatch();
     const navigate = useNavigate();
  const { data, list, status, error } = useSelector(
    (state) => state.sourceConversionReport
  );

  useEffect(() => {
    dispatch(fetchSourceConversionReport("monthly")); // Fetch weekly data by default
  }, [dispatch]);

  const handlePeriodChange = (period) => {
    dispatch(fetchSourceConversionReport(period));
  };

  // Prepare data for charts
  const chartData = {
    labels: data.map((item) => item.lead_type), // Lead types
    datasets: [
      {
        label: "Lead Type Counts",
        data: data.map((item) => item.count), // Counts for each lead type
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(255, 99, 132, 0.6)",
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const maxCount = Math.max(...data.map((item) => item.count));
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      // title: {
      //   display: true,
      //   text: "Weekly Leads Report",
      // },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: maxCount, // Set Y-axis maximum to the highest count
        ticks: {
          stepSize: 1, // Increment by 1 for each line
          callback: function (value) {
            return value; // Return actual value for the tick label
          },
        },
      },
      x: {
        beginAtZero: true, // Ensure Y-axis starts at zero
      },
    },
  };
  const handleShowData=()=>{
    navigate("/admin/data-table", { state: { leadsData: list } }); // Pass the data as route state
  }
  return (
<div className="bg-white p-4 rounded-md shadow-md">
  <div className="flex justify-between items-center mb-4">
    <h1 className="font-bold text-lg">Source Conversion Report</h1>
    <div className="flex gap-2">
      <button
        onClick={() => handlePeriodChange("weekly")}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
      >
        Weekly
      </button>
      <button
        onClick={() => handlePeriodChange("monthly")}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
      >
        Monthly
      </button>
      <button
        onClick={() => handlePeriodChange("yearly")}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
      >
        Yearly
      </button>
    </div>
    <button
        onClick={handleShowData}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Show Data
      </button>
  </div>

  {status === "loading" && (
    <p className="text-center text-gray-500">Loading...</p>
  )}
  {status === "failed" && (
    <p className="text-center text-red-500">Error: {error}</p>
  )}
  {status === "succeeded" && (
    <div>
      <Bar data={chartData} options={chartOptions} />
    </div>
  )}
</div>


  );
};

export default SourceConversionReport;
